/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @nx/enforce-module-boundaries
import moment from 'moment';
/* eslint-disable @nx/enforce-module-boundaries */
import { logger } from '@marriott/mi-headless-utils';
import {
  EXTERNAL_CTA_TYPE,
  HOTEL_VIEW,
  MARRIOTT_CACHE_URL,
  outputInterpolation,
  outputQuality,
  VIEW_RATE_LABEL,
  METERSTOKM,
  METERSTOMILES,
  DESTINATION_FEE_CODE_DESCRIPTION,
  INCLUDES_LABEL,
  RESORT_FEE_DESCRIPTION,
  SURCHARGE_ORDINANCE_COST_DESCRIPTION,
  DESTINATION_FEE_DESCRIPTION,
  TOURISM_MARKETING_FEE_DESCRIPTION,
  HOTEL_MARKETING_CAPTION,
} from '../../../constants/CommonConstants';
import { milesToMeters, isValidNumberString } from '../../../utils/CommonUtils';

import { constructMandatoryFeeTitle, constructToolTipTitle, identifyTypeOfMandatoryFee } from './ratesHelper';
import { getDateFormatted } from './dateUtils';

export function getCalculatedDistance(dist: number | undefined, km: boolean, lang?: string): string | null {
  /** calculated distance for km/ miles */
  if (dist) {
    if (km) {
      // convert meters to km
      return formatNumberByLocale((dist / METERSTOKM).toFixed(1), lang || '');
    } else {
      // convert meters to miles
      return formatNumberByLocale((dist / METERSTOMILES).toFixed(1), lang || '');
    }
  }
  return null;
}
export const getSortByVal = (sortBySessionVal: any, destinationData: any): string => {
  if (sortBySessionVal) {
    return sortBySessionVal;
  } else {
    if (destinationData?.isCountryEnabled || destinationData?.isStateEnabled) {
      return 'CITY';
    } else {
      return 'DISTANCE';
    }
  }
};
export const getSortByOptions = (model: any, isStateOrCountryEnabled: boolean) => {
  const optionsList = [
    {
      sortByOptionTitle: model?.priceLowToHighLabel,
      sortByOptionCode: 'PRICE',
    },
    {
      sortByOptionTitle: model?.cityLabel,
      sortByOptionCode: 'CITY',
    },
    {
      sortByOptionTitle: model?.storefrontPropertyBrandFilter,
      sortByOptionCode: 'BRAND',
    },
    {
      sortByOptionTitle: model?.guestRatingLabel,
      sortByOptionCode: 'GUEST_RATINGS',
    },
    {
      sortByOptionTitle: model?.noOfReviewsLabel,
      sortByOptionCode: 'NUM_REVIEWS',
    },
  ];

  if (!isStateOrCountryEnabled) {
    optionsList.unshift({
      sortByOptionTitle: model?.distanceLabel,
      sortByOptionCode: 'DISTANCE',
    });
  }

  return optionsList;
};
export const getSearchResultQuery = (
  searchData: any,
  destinationMetaData: any,
  offset: any,
  brandFacets: any,
  limit: any,
  sortBy: any,
  amentiesFacets: any,
  transportaionFacets: any,
  hotelTypeFacets: any,
  eventsFacets: any,
  activitiesFacets: any,
  priceDimension: any,
  cityFacets: any,
  stateFacets: any,
  includeUnavailableProperties: boolean,
  showPricesTax: boolean,
  currentLocale: any,
  mandatoryFeesEnabled: boolean,
  sersidecall?: boolean,
  serverSideoffset?: any,
  ariesOffer?: any,
  countryCode?: any,
  hasdestinationChanged?: any
): any => {
  const taxFlag = currentLocale === 'en-US' && countryCode != 'GB' && countryCode != 'JP' ? false : true; // currentLocale === es-ES

  const showPricesTaxServer = hasdestinationChanged ? taxFlag : ariesOffer?.['showPricesTax'] ?? taxFlag;
  const includeTaxesAndFees = sersidecall ? showPricesTaxServer : showPricesTax;
  const includeMandatoryFees = mandatoryFeesEnabled;
  console.log(includeMandatoryFees, currentLocale, 'EHH!!');
  const sessionBrandFacetList = hasdestinationChanged
    ? []
    : ariesOffer && ariesOffer?.['selectedBrands']
    ? ariesOffer?.['selectedBrands']?.map((item: any) => item.code)
    : [];
  const sessionAmenitiesFacetList = hasdestinationChanged
    ? []
    : ariesOffer && ariesOffer?.['selectedAmenities']
    ? ariesOffer?.['selectedAmenities']?.map((item: any) => item?.code)
    : [];
  console.log('[destination] server - facets >>', sessionAmenitiesFacetList);
  console.log('[destination] server - sersidecall >>', sersidecall);
  const sessionTransportaionFacetList = hasdestinationChanged
    ? []
    : ariesOffer && ariesOffer?.['selectedTransportaion']
    ? ariesOffer?.['selectedTransportaion'].map((item: any) => item?.code)
    : [];

  const sessionHotelTypeFacetList = hasdestinationChanged
    ? []
    : ariesOffer && ariesOffer?.['selectedHotelType']
    ? ariesOffer?.['selectedHotelType'].map((item: any) => item?.code)
    : [];

  const sessionEventsFaceList = hasdestinationChanged
    ? []
    : ariesOffer && ariesOffer?.['selectedEvents']
    ? ariesOffer?.['selectedEvents'].map((item: any) => item?.code)
    : [];

  const sessionActivitiesFacetList = hasdestinationChanged
    ? []
    : ariesOffer && ariesOffer?.['selectedActivities']
    ? ariesOffer?.['selectedActivities'].map((item: any) => item?.code)
    : [];

  const sessionCitiesFacetList = hasdestinationChanged
    ? []
    : ariesOffer && ariesOffer?.['selectedCity']
    ? ariesOffer?.['selectedCity'].map((item: any) => item?.code)
    : [];

  const priceRange = hasdestinationChanged
    ? 'Any Price'
    : ariesOffer && ariesOffer?.['selectedPrices']
    ? ariesOffer?.['selectedPrices']?.[0]?.label
    : 'Any Price';

  const serverSideAvailibilityFlag = hasdestinationChanged
    ? true
    : (ariesOffer && ariesOffer?.['includeUnavailableProperties']) ?? true;

  const keepDefaultFilters =
    destinationMetaData?.amenities?.length > 0 ||
    destinationMetaData?.activities?.length > 0 ||
    destinationMetaData?.hotelType?.length > 0;

  const defaultAminities = keepDefaultFilters
    ? (destinationMetaData?.amenities || []).concat(sessionAmenitiesFacetList)
    : sessionAmenitiesFacetList;
  const defaultActivities = keepDefaultFilters
    ? (destinationMetaData?.activities || []).concat(sessionActivitiesFacetList)
    : sessionActivitiesFacetList;
  const defaultHotelType = keepDefaultFilters
    ? (destinationMetaData?.hotelType || []).concat(sessionHotelTypeFacetList)
    : sessionHotelTypeFacetList;

  const key = priceRange as keyof typeof priceDimensionMapping;
  const priceDimensionVal = priceDimensionMapping[key];
  const sortBySessionVal = ariesOffer?.['sortBy'];
  const sortByVal = sersidecall ? sortBySessionVal : sortBy;
  const sortDirection = sortByVal === 'GUEST_RATINGS' || sortByVal === 'NUM_REVIEWS' ? 'DESC' : 'ASC';
  const obj: any = {
    search: {
      options: {
        startDate: searchData?.startDate,
        endDate: searchData?.endDate,
        includeUnavailableProperties: sersidecall ? serverSideAvailibilityFlag : includeUnavailableProperties,
        includeTaxesAndFees: includeTaxesAndFees,
        numberInParty: searchData?.numberInParty,
        quantity: searchData?.quantity,
        childAges: searchData?.childAges,
        rateRequestTypes: [
          {
            type: 'STANDARD',
            value: '',
          },
        ],
        includeMandatoryFees: includeMandatoryFees,
      },
      facets: {
        terms: [
          {
            type: 'BRANDS',
            dimensions: sersidecall ? sessionBrandFacetList : brandFacets,
          },
          {
            type: 'AMENITIES',
            dimensions: sersidecall ? defaultAminities : amentiesFacets,
          },
          {
            type: 'PROPERTY_TYPES',
            dimensions: sersidecall ? defaultHotelType : hotelTypeFacets,
          },
          {
            type: 'ACTIVITIES',
            dimensions: sersidecall ? defaultActivities : activitiesFacets,
          },
          {
            type: 'MEETINGS_EVENTS',
            dimensions: sersidecall ? sessionEventsFaceList : eventsFacets,
          },
          {
            type: 'TRANSPORTATION_TYPES',
            dimensions: sersidecall ? sessionTransportaionFacetList : transportaionFacets,
          },
        ],
        ranges: [
          {
            type: 'PRICE',
            dimensions: sersidecall ? priceDimensionVal : priceDimension,
            endpoints: ['0', '100', '200', 'overflow'],
          },
          {
            type: 'DISTANCE',
            dimensions: [],
            endpoints: ['0', '5000', '15000', '80000'],
          },
        ],
      },
      ...(!destinationMetaData?.isCountryEnabled &&
        !destinationMetaData?.isStateEnabled &&
        destinationMetaData?.radius !== null &&
        isValidNumberString(destinationMetaData.radius) && { distance: milesToMeters(destinationMetaData.radius) }),
    },
    sort: {
      fields: [
        {
          field: sortByVal,
          direction: sortDirection,
        },
      ],
    },
    filter: [
      HOTEL_MARKETING_CAPTION,
      RESORT_FEE_DESCRIPTION,
      DESTINATION_FEE_DESCRIPTION,
      SURCHARGE_ORDINANCE_COST_DESCRIPTION,
      TOURISM_MARKETING_FEE_DESCRIPTION,
    ],
    phoneFilter: ['PHONE'],
    modes: ['LOWEST_AVERAGE_NIGHTLY_RATE', 'POINTS_PER_UNIT'],
    offset: sersidecall ? serverSideoffset : offset,
    limit: limit,
    limitPerCategory: 2,
  };

  interface filterType {
    type: string;
    dimensions: any;
  }
  interface sortType {
    field: string;
    direction: string;
  }
  if (
    !destinationMetaData?.isStateEnabled &&
    !destinationMetaData?.isCountryEnabled &&
    destinationMetaData?.latitude &&
    destinationMetaData?.longitude
  ) {
    obj.search['latitude'] = parseFloat(destinationMetaData?.latitude ?? 0);
    obj.search['longitude'] = parseFloat(destinationMetaData?.longitude ?? 0);
  }
  const filterDetails: filterType[] = [
    {
      type: 'CITIES',
      dimensions: sersidecall ? sessionCitiesFacetList : cityFacets,
    },
    {
      type: 'STATES',
      dimensions: destinationMetaData?.isStateEnabled ? [destinationMetaData?.stateCode] : stateFacets,
    },
    {
      type: 'COUNTRIES',
      dimensions:
        (destinationMetaData?.isStateEnabled || destinationMetaData?.isCountryEnabled) &&
        destinationMetaData?.countryCode
          ? [destinationMetaData?.countryCode]
          : [],
    },
  ];
  obj.search.facets.terms.push(...filterDetails);
  return obj;
};

const getTitle = (property: any, brandId: string, model: any, subdirectory: any) => {
  const seoNickname = property?.seoNickname ?? '';
  const titleDetails = {
    title: property?.basicInformation?.name,
    titleAriaLabel: property?.basicInformation?.name,
    isTitleLink: true,
    titleClickCallback: () => {
      const detailsPage =
        brandId == 'RZ'
          ? `https://www.ritzcarlton.com/en/hotels/${seoNickname}/overview/`
          : (subdirectory ? `/${subdirectory}` : '/en-us') + `/hotels/${seoNickname}/overview/`;

      window.open(`${detailsPage}`, '_blank');
    },
    titleLink:
      brandId == 'RZ'
        ? `https://www.ritzcarlton.com/en/hotels/${seoNickname}/overview/`
        : (subdirectory ? `/${subdirectory}` : '/en-us') + `/hotels/${seoNickname}/overview/`,
    titleClickTrackVal: `${model?.id}|${property?.id}|${EXTERNAL_CTA_TYPE}`,
  };
  return titleDetails;
};
const getReviewDetails = (
  property: any,
  brandId: string,
  distance: any,
  model: any,
  subdirectory: any,
  lang: string
) => {
  const seoNickname = property?.seoNickname;
  const rating = property?.reviews?.stars?.count ?? 0;
  const reviewCount = property?.reviews?.numberOfReviews?.count ?? 0;
  const reviewUrl =
    brandId == 'RZ'
      ? `https://www.ritzcarlton.com/en/hotels/${seoNickname}/overview/`
      : (subdirectory ? `/${subdirectory}` : '/en-us') + `/hotels/${seoNickname}/reviews/`;
  const distanceInMiles = getCalculatedDistance(distance, lang !== 'en-US', lang);
  const reviewDetails = {
    ...(rating !== 0 && { reviewsAvg: rating }),
    ...(reviewCount !== 0 && { reviewsText: `(${reviewCount} ${model?.storefrontPropertyReviews})` }),
    reviewsLink: reviewUrl,
    reviewsLabel: '',
    reviewsClickTrackValue: `${model?.id}|${property?.id}-${model?.storefrontPropertyReviews}|${EXTERNAL_CTA_TYPE}`,
    milesText:
      distanceInMiles !== null && distanceInMiles !== undefined
        ? `${distanceInMiles} ${model?.unitFromDestinationLabel}`
        : '',
  };
  return reviewDetails;
};
const getDescriptionText = (descriptions: any) => {
  return descriptions?.find((desc: any) => desc?.type?.enumCode === HOTEL_MARKETING_CAPTION)?.text || '';
};

const getImageSetup = (viewPort: any) => {
  let imageDimensions = {
    height: 222,
    width: 715,
  };
  if (viewPort === 'mobile') {
    imageDimensions = {
      height: 240,
      width: 360,
    };
  } else {
    imageDimensions = {
      height: 222,
      width: 715,
    };
  }
  return imageDimensions;
};
const getImageProps = (viewPort: any): string => {
  const imageDimensions = getImageSetup(viewPort);
  const imgProp =
    `?output-quality=${outputQuality}&interpolation=${outputInterpolation};*,*&downsize=` +
    imageDimensions.width +
    'px:*';
  return imgProp;
};
const getPropertyImages = (data: any, viewPort: any) => {
  const imageProperties = getImageProps(viewPort);
  const photoGalleryObj = data?.media?.photoGallery;
  const propertyImageList: any = [];
  const propertyImageArray: any = [];
  let cauroselImages: any = [];
  const edgesList: any = [];

  if (photoGalleryObj) {
    Object.keys(photoGalleryObj).forEach((categoryKey: any) => {
      const propertyObject: any = [];
      if (categoryKey !== '__typename' && photoGalleryObj[categoryKey]) {
        propertyObject['categoryCode'] = categoryKey;
        propertyObject['photosObj'] = photoGalleryObj[categoryKey];
        propertyImageList.push(propertyObject);
      }
    });
  }
  if (data?.media?.primaryImage?.edges?.[0]?.node?.imageUrls) {
    const hotelViewObj: any = [];
    hotelViewObj['categoryCode'] = HOTEL_VIEW;
    hotelViewObj['photosObj'] = data?.media?.primaryImage;
    propertyImageList.unshift(hotelViewObj);
  }
  propertyImageList.map((edgeCollection: any) => {
    edgesList.push(edgeCollection?.photosObj?.edges);
    edgesList.map((photosList: any) => {
      photosList.map((imgNode: any) => {
        const wideImg = imgNode?.node?.imageUrls?.wideHorizontal;
        const altText = imgNode?.node?.alternateDescription || '';
        if (wideImg !== null && wideImg !== '') {
          propertyImageArray.push({
            defaultImageUrl: MARRIOTT_CACHE_URL + wideImg + imageProperties,
            altText: altText,
          });
          cauroselImages = Array.from(
            new Map(propertyImageArray.map((item: any) => [item.defaultImageUrl, item])).values()
          ).slice(0, 10);
        }
      });
    });
  });
  if (cauroselImages.length < 1) {
    const brandFallbackImageArray: any = {};
    brandFallbackImageArray['defaultImageUrl'] = data?.basicInformation?.brand?.photos?.[0]?.content[0]?.url;
    brandFallbackImageArray['altText'] = data?.basicInformation?.name ?? '';
    cauroselImages.push(brandFallbackImageArray);
  }
  return cauroselImages;
};
const generateDetailsPageURL = (seoNickname: string, brandId: string, model: any, subdirectory: any) => {
  const detailsPage =
    brandId == 'RZ'
      ? `https://www.ritzcarlton.com/en/hotels/${seoNickname}/overview/`
      : (subdirectory ? `/${subdirectory}` : '/en-us') + `/hotels/${seoNickname}/overview/`;
  const footerlinks = {
    href: detailsPage,
    target: '_blank',
    custom_click_track_value: `${model?.id}|${model?.storefrontPropertyHotelDetails}|${EXTERNAL_CTA_TYPE}`,
    rel: 'noreferrer',
    className: 'm-link-tertiary-button outlet-resevation-link custom_click_track ',
    buttonCopy: `${model?.storefrontPropertyHotelDetails}`,
    isLink: true,
    onClick: () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      (): Window | null => window.open(`${detailsPage}`, '_self');
    },
  };
  return footerlinks;
};
const getRatesNode = (hotel: any) => {
  return hotel?.node?.rates?.[0];
};
const calculateRates = (LARNode: any, isDTT?: any) => {
  const Enable_DTT_queries = isDTT; //TBD
  const rateStatus = LARNode?.status?.code ?? 'unavailable';
  let price = 0;
  if (rateStatus === 'available' || rateStatus === 'AvailableForSale') {
    let cashValue = 0;
    let decimalValue = 0;
    if (!Enable_DTT_queries) {
      cashValue =
        LARNode?.rateAmounts?.[0]?.amountPlusMandatoryFees?.origin?.value ??
        LARNode?.rateAmounts?.[0]?.amount?.origin?.value;

      decimalValue = LARNode?.rateAmounts?.[0]?.amountPlusMandatoryFees?.origin?.value
        ? LARNode?.rateAmounts?.[0]?.amountPlusMandatoryFees?.origin?.valueDecimalPoint
        : LARNode?.rateAmounts?.[0]?.amount?.origin?.value
        ? LARNode?.rateAmounts?.[0]?.amount?.origin?.valueDecimalPoint
        : 0;
    } else {
      cashValue =
        LARNode?.rateModes?.lowestAverageRate?.amountPlusMandatoryFees?.amount ??
        LARNode?.rateModes?.lowestAverageRate?.amount?.amount;

      decimalValue = LARNode?.rateModes?.lowestAverageRate?.amountPlusMandatoryFees?.amount
        ? LARNode?.rateModes?.lowestAverageRate?.amountPlusMandatoryFees?.decimalPoint
        : LARNode?.rateModes?.lowestAverageRate?.amount?.amount
        ? LARNode?.rateModes?.lowestAverageRate?.amount?.decimalPoint
        : 0;
    }
    price = Math.round(cashValue / Math.pow(10, decimalValue as number));
  }
  return {
    price: price,
  };
};
const getFooterDetails = (
  hotel: any,
  clusterCode: string,
  model: any,
  subdirectory: any,
  acceptLanguage: any,
  showPricesTax?: any,
  isDTT?: any
) => {
  const Enable_DTT_queries = isDTT; //TBD
  const dateFlag =
    acceptLanguage === 'it-IT' ||
    acceptLanguage === 'fr-FR' ||
    acceptLanguage === 'pt-BR' ||
    acceptLanguage === 'es-ES' ||
    acceptLanguage === 'en-GB'
      ? true
      : false;
  const formatDate = (date: any) => date.toISOString().split('T')[0];

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const startDate = formatDate(today);
  const endDate = formatDate(tomorrow);

  const searchData = {
    startDate: startDate,
    endDate: endDate,
    childAges: [],
    numberInParty: 1,
    quantity: 1,
  };
  const ratePage =
    (subdirectory ? `/${subdirectory}` : '') +
    '/reservation/availabilitySearch.mi?' +
    `&numberOfRooms=${searchData?.quantity}&numberOfAdults=${
      Number(searchData?.numberInParty) - (searchData?.childAges?.length ?? 0)
    }&childrenCount=${searchData?.childAges?.length ?? ''}&childrenAges=${
      searchData?.childAges?.length ? searchData?.childAges.map((i: any) => (Number.isNaN(Number(i)) ? '0' : i)) : ''
    }` +
    `currency=${hotel?.node?.property?.basicInformation?.currency}` +
    '&useRewardsPoints=false&isRateCalendar=true&isSearch=true' +
    '&fromDate=' +
    getDateFormatted(moment(searchData?.startDate), dateFlag ? 'DD/MM/YYYY' : 'MM/DD/YYYY') +
    '&toDate=' +
    getDateFormatted(moment(searchData?.endDate), dateFlag ? 'DD/MM/YYYY' : 'MM/DD/YYYY') +
    `&clusterCode=${clusterCode === '0' ? 'none' : 'corp'}` +
    '&propertyCode=' +
    hotel?.node?.property?.id;

  const rateObj = getRatesNode(hotel);

  let rate;
  if (showPricesTax) {
    const mandatoryFee = getPriceOnToggleSelection(hotel, isDTT);
    const amount = Enable_DTT_queries ? mandatoryFee?.amount : mandatoryFee?.value;
    const decimalPoint = Enable_DTT_queries ? mandatoryFee?.decimalPoint : mandatoryFee?.valueDecimalPoint;
    const totalPrice = mandatoryFee && amount ? Math.round(amount / Math.pow(10, decimalPoint as number)) : 0;
    rate = totalPrice;
  } else {
    const totalrates = calculateRates(rateObj, isDTT);
    rate = totalrates?.price;
  }

  const footerlinks = {
    href: ratePage,
    target: '_self',
    ratesClickTrackValue: `${model?.id}|${hotel?.node?.property?.id}-${model?.bookNow}|${EXTERNAL_CTA_TYPE}`,
    rel: 'noreferrer',
    className: 'm-button-s m-button-primary custom_click_track reserve-cta-button',
    text: `${model?.bookNow}`,
    isLink: false,
    hasPrice: rate > 0 ? true : false,
    priceAriaLabel: '',
    priceClickTrackValue: `${model?.id}|${hotel?.node?.property?.id}-${model?.storefrontPropertyPointsPerStay}|${EXTERNAL_CTA_TYPE}`,
    priceValue: rate ?? null,
    priceType: rate && `${hotel?.node?.property?.basicInformation?.currency} / ${model?.storefrontPropertyNight}`,
    currency: hotel?.node?.property?.basicInformation?.currency,
    unavailableRateText: model?.rateUnavailable,
  };
  return footerlinks;
};
const getPriceOnToggleSelection = (hotel: any, isDTT?: any) => {
  const Enable_DTT_queries = isDTT; //TBD
  let amount;
  if (Enable_DTT_queries) {
    const lowestAverageRate = hotel?.node?.rates?.[0]?.rateModes?.lowestAverageRate;
    amount = lowestAverageRate?.totalAmount;
  } else {
    amount =
      hotel?.node?.rates?.[0]?.rateAmounts?.[0]?.totalAmount ??
      hotel?.node?.rates?.[0]?.rateAmounts?.[0]?.amount?.origin;
  }

  return amount;
};

const getAmountPlusMandatoryFeeDetails = (
  hotel: any,
  acceptLanguage: any,
  countryCode: any,
  showPricesTax: any,
  isDTT?: any
) => {
  const Enable_DTT_queries = isDTT; //TBD
  const rateObj = getRatesNode(hotel);
  const rateStatus = rateObj?.status?.code ?? 'unavailable';
  let mandatoryFee;

  if (rateStatus === 'available' || rateStatus === 'AvailableForSale') {
    if (showPricesTax) {
      mandatoryFee = getPriceOnToggleSelection(hotel, isDTT);
    } else {
      let feeObj;
      if (acceptLanguage.toLocaleLowerCase() === 'ja-jp' || countryCode === 'JP') {
        feeObj = Enable_DTT_queries
          ? rateObj?.rateModes?.lowestAverageRate?.amount
          : rateObj?.rateAmounts?.[0]?.amount?.origin;
      } else {
        feeObj = Enable_DTT_queries
          ? rateObj?.rateModes?.lowestAverageRate?.amountPlusMandatoryFees ??
            rateObj?.rateModes?.lowestAverageRate?.amount
          : rateObj?.rateAmounts?.[0]?.amountPlusMandatoryFees?.origin ?? rateObj?.rateAmounts?.[0]?.amount?.origin;
      }
      mandatoryFee = feeObj ?? {};
    }
  }
  const amount = Enable_DTT_queries ? mandatoryFee?.amount : mandatoryFee?.value;
  const decimalPoint = Enable_DTT_queries ? mandatoryFee?.decimalPoint : mandatoryFee?.valueDecimalPoint;
  const totalPrice = mandatoryFee && amount ? Math.round(amount / Math.pow(10, decimalPoint as number)) : 0;
  return totalPrice;
};
const getMandatoryFeeDetails = (hotel: any, mandatoryFeesEnabled: boolean, isDTT?: any) => {
  if (!mandatoryFeesEnabled) {
    return;
  }
  const Enable_DTT_queries = isDTT;
  const rateObj = getRatesNode(hotel);
  const mandatoryFee = Enable_DTT_queries
    ? rateObj?.rateModes?.lowestAverageRate?.mandatoryFees
    : rateObj?.rateAmounts?.[0]?.mandatoryFees?.origin;
  const mandatoryFeeDTT = {
    currency: mandatoryFee?.currency,
    value: mandatoryFee?.value ?? mandatoryFee?.amount,
    valueDecimalPoint: mandatoryFee?.decimalPoint ?? mandatoryFee?.valueDecimalPoint,
  };
  return mandatoryFeeDTT;
};
const getMandatoryFeeDescription = (descriptions: any) => {
  const mandatoryFeeDescObj =
    descriptions.length > 0
      ? descriptions.filter((item: { type: { enumCode: string } }) => {
          const code = item?.type?.enumCode ?? '';
          if (code === RESORT_FEE_DESCRIPTION) {
            return true;
          } else if (code === SURCHARGE_ORDINANCE_COST_DESCRIPTION) {
            return true;
          } else if (code === DESTINATION_FEE_DESCRIPTION || code === DESTINATION_FEE_CODE_DESCRIPTION) {
            return true;
          } else if (code === TOURISM_MARKETING_FEE_DESCRIPTION) {
            return true;
          }
          return false;
        })
      : [];
  return mandatoryFeeDescObj;
};
//modify card data helper functions
export const modifyPropertyCardData = (
  resp: any,
  isStateOrCountryEnabled: any,
  model: any,
  normalizedLocale: any,
  currentLocale: any,
  mandatoryFeesEnabled: boolean,
  countryCode?: any,
  showPricesTax?: any,
  isDTT?: any,
  viewPort?: any
) => {
  console.log(
    `[destination] [server] modifyPropertyCardData >> isStateOrCountryEnabled: ${isStateOrCountryEnabled}, countryCode: ${countryCode}, isDTT: ${isDTT} `
  );

  const Enable_DTT_queries = isDTT;
  const respObj = Enable_DTT_queries
    ? isStateOrCountryEnabled
      ? resp?.data?.search?.lowestAvailableRates?.searchByLocation ?? {}
      : resp?.data?.search?.lowestAvailableRates?.searchByGeolocation ?? {}
    : isStateOrCountryEnabled
    ? resp?.data?.searchLowestAvailableRatesByLocation ?? {}
    : resp?.data?.searchLowestAvailableRatesByGeolocation ?? {};

  const edgeObj = respObj?.edges ?? [];
  const totalProperties = respObj?.total ?? 0;
  const propList = edgeObj;

  const hotels = propList.length
    ? propList.map((hotel: any) => {
        const {
          fullyRenovatedLabel,
          recentlyRenovatedLabel,
          newTagLabel,
          adultsOnlyLabel,
          renovatedLobbyLabel,
          renovatedRoomsLabel,
        } = model || {};
        const { basicInformation } = hotel?.node?.property || {};
        const isFullyRenovated = basicInformation?.isFullyRenovated;
        const isRecentlyRenovated = basicInformation?.isRecentlyRenovated;
        const hasRenovatedRooms = basicInformation?.hasRenovatedRooms;
        const newProperty = basicInformation?.newProperty;
        const isAdultsOnly = basicInformation?.isAdultsOnly;
        const newLobby = basicInformation?.newLobby;
        const { isResort, isLACountyFee, isMarketingFee, isDestinationFee } =
          identifyTypeOfMandatoryFee(basicInformation);
        const mandatoryFeeTitle = constructMandatoryFeeTitle(
          isResort,
          isLACountyFee,
          isMarketingFee,
          isDestinationFee,
          model
        );
        const mandatoryFeeMessages = {
          title: constructToolTipTitle(isResort, isLACountyFee, isMarketingFee, isDestinationFee, model),
          feeDescription1: model?.includesLabel ?? INCLUDES_LABEL,
          feeDescription2: mandatoryFeeTitle ?? model?.feeDescription2,
          viewRatesLabel: model?.viewRatesLabel ?? VIEW_RATE_LABEL,
        };
        let ribbonDetails = null;
        if (isFullyRenovated) {
          ribbonDetails = {
            ribbonText: fullyRenovatedLabel,
            ribbonClass: 'fully-renovated-ribbon',
          };
        } else if (isRecentlyRenovated) {
          ribbonDetails = {
            ribbonText: recentlyRenovatedLabel,
            ribbonClass: 'recently-renovated-ribbon',
          };
        } else if (newProperty) {
          ribbonDetails = {
            ribbonText: newTagLabel,
            ribbonClass: 'new-hotel-ribbon ribbon',
          };
        } else if (isAdultsOnly) {
          ribbonDetails = {
            ribbonText: adultsOnlyLabel,
            ribbonClass: 'adult-hotel-ribbon',
          };
        } else if (newLobby) {
          ribbonDetails = {
            ribbonText: renovatedLobbyLabel,
            ribbonClass: 'renovated-lobby-ribbon',
          };
        } else if (hasRenovatedRooms) {
          ribbonDetails = {
            ribbonText: renovatedRoomsLabel,
            ribbonClass: 'renovated-rooms-ribbon',
          };
        }
        return {
          id: hotel?.node?.property?.id ?? '',
          sid: hotel?.node?.property?.basicInformation?.marshaBrandCode ?? '',
          brandCode: hotel?.node?.property?.basicInformation?.brand?.id ?? '',
          titleDetails: getTitle(
            hotel?.node?.property,
            hotel?.node?.property?.basicInformation?.brand?.id,
            model,
            normalizedLocale
          ),
          reviewsDetails: getReviewDetails(
            hotel?.node?.property,
            hotel?.node?.property?.basicInformation?.brand?.id,
            hotel?.node?.distance,
            model,
            normalizedLocale,
            currentLocale
          ),
          description: getDescriptionText(hotel?.node?.property?.basicInformation?.descriptions),
          images: getPropertyImages(hotel?.node?.property, viewPort),
          tertiaryLinkDetails: generateDetailsPageURL(
            hotel?.node?.property?.seoNickname ?? '',
            hotel?.node?.property?.basicInformation?.brand?.id,
            model,
            normalizedLocale
          ),
          footerLinkDetails: getFooterDetails(hotel, '0', model, normalizedLocale, currentLocale, showPricesTax, isDTT),
          mandatoryFeeObj: {
            amountPlusMandatoryFee: getAmountPlusMandatoryFeeDetails(
              hotel,
              currentLocale,
              countryCode,
              showPricesTax,
              isDTT
            ),
            mandatoryFee: getMandatoryFeeDetails(hotel, mandatoryFeesEnabled, isDTT),
            mandatoryFeeDescription: getMandatoryFeeDescription(hotel?.node?.property?.basicInformation?.descriptions),
            ...mandatoryFeeMessages,
          },
          brandDetails: {
            brandId: hotel?.node?.property?.basicInformation?.brand?.id,
            label: '',
            hasUniquePropertyLogo: hotel?.node?.property?.basicInformation?.hasUniquePropertyLogo,
          },
          ribbonDetails: ribbonDetails,
        };
      })
    : [];
  return {
    hotels: hotels,
    totalProperties: totalProperties,
  };
};

export const getPageCardCountInfo = (cardsTotalCount: number, currentPage: any, model: any): string => {
  const cardsCount = model?.propertiesPerPage ? Number(model?.propertiesPerPage) : 8;
  const total = Math.ceil(cardsTotalCount / cardsCount);
  const start = total === 1 || currentPage === 1 ? 1 : (currentPage - 1) * cardsCount + 1;
  const end = total === currentPage || currentPage === cardsTotalCount ? cardsTotalCount : currentPage * cardsCount;
  const countText = `${model?.showing} ${start}-${end} ${model?.of} ${cardsTotalCount} ${model?.hotel}`;
  return countText;
};

export const getProcessedData = (
  propertiesListdata: any,
  isStateOrCountryEnabled: any,
  model: any,
  normalizedLocale: any,
  currentLocale: any,
  currentPage: any,
  mandatoryFeesEnabled: boolean,
  countryCode?: any,
  ariesOffer?: any,
  isDTT?: any,
  viewPort?: any
) => {
  const taxFlag = currentLocale === 'en-US' && countryCode !== 'GB' && countryCode !== 'JP' ? false : true;
  const showPricesTax = ariesOffer?.['showPricesTax'] ?? taxFlag;
  // const currencyConversionRate = ariesOffer?.['currencyConversionRate'] ?? 1;
  console.log('[destination] [server] showPricesTax >>', showPricesTax);
  console.log('[destination] [server] Aries offer helper >>', JSON.stringify(ariesOffer ? ariesOffer : ''));
  const modifiedPropertyCardData = modifyPropertyCardData(
    propertiesListdata,
    isStateOrCountryEnabled,
    model,
    normalizedLocale,
    currentLocale,
    mandatoryFeesEnabled,
    countryCode,
    showPricesTax,
    isDTT,
    viewPort
  );
  console.log(`[Destination PropertiesList] modifiedPropertyCardData: ${JSON.stringify(modifiedPropertyCardData)}`);
  const selectedCurrency = ariesOffer?.['selectedCurrency'];
  const cardCountText = getPageCardCountInfo(modifiedPropertyCardData.totalProperties, currentPage, model);
  return {
    hotels: modifiedPropertyCardData?.hotels,
    totalProperties: modifiedPropertyCardData.totalProperties,
    cardCountText: cardCountText,
    showPricesTax: showPricesTax,
    // defaultCurrency: currencyfromUxl,
    selectedCurrency: selectedCurrency,
    currencyConversionRate: propertiesListdata?.currencyConversionRate,
  };
};
export const getCommaSeparator = (numb: number, lang: string) => {
  return numb ? Number(Math.floor(numb))?.toLocaleString(lang || '') : null;
};

export const priceDimensionMapping = {
  'Any Price': [],
  '0 - 100 USD': ['1'],
  '100 - 200 USD': ['2'],
  '200+ USD': ['3'],
};

export const formatNumberByLocale = (numb: number | string, lang: string): string => {
  const { log } = logger({})('formatNumberByLocale');
  log.debug(
    `[PerfTesting][utils] Entering the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  const inputStr = numb ?? '';
  // convert input number to locale string according to the lang
  let str = '';
  switch (lang) {
    case 'ko-KR':
    case 'ja-JP':
    case 'it-IT':
    case 'fr-FR':
    case 'de-DE':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2 });
      break;
    case 'ru-RU':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2 });
      break;
    case 'pt-BR':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 3 });
      break;
    case 'es-ES':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2, useGrouping: true });
      break;
    case '':
    case undefined:
      str = Number(inputStr)?.toLocaleString();
      break;
    default:
      str = Number(inputStr)?.toLocaleString(lang || '');
      break;
  }
  log.debug(
    `[PerfTesting][utils] Exiting the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  return str;
};

export const getUserAgentType = (userAgent: string): string => {
  const userAgentType = userAgent.toLowerCase();
  console.log(userAgentType, 'userAgentType in common util');
  if (userAgentType.indexOf('android') > -1 || userAgentType.indexOf('iphone') > -1) {
    return 'mobile';
  } else {
    return 'desktop';
  }
};
